import React, { useState } from "react"
import { Radio, Button } from "antd"
import { PRIMARY_BTN_STYLE } from "./constants"

const RadioGroupQuestion = ({ wizardMeta, answered, onRespond }) => {
  const { options, defaultValue } = wizardMeta
  const [value, setValue] = useState(defaultValue || (options[0] && options[0].value))

  return (
    <div className="wizard-radio-group" style={{ marginTop: 8 }}>
      <Radio.Group
        onChange={(e) => setValue(e.target.value)}
        value={value}
        disabled={answered}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}
      >
        {options.map((opt) => (
          <Radio key={opt.value} value={opt.value} style={{ whiteSpace: "normal" }}>
            <strong>{opt.label}</strong>
            {opt.description && <span style={{ color: "#5a6a7a" }}>{`: ${opt.description}`}</span>}
          </Radio>
        ))}
      </Radio.Group>
      {!answered && (
        <Button
          style={{ ...PRIMARY_BTN_STYLE, marginTop: 10 }}
          onClick={() => onRespond({ value })}
        >
          Confirm
        </Button>
      )}
    </div>
  )
}

export default RadioGroupQuestion
